import React from "react";
import { Modal } from "../../ecosystem/";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import { Prompt } from "react-router-dom";
import { Redirect } from 'react-router';
import { connect } from "react-redux";

class CareGapsConfirmationModal extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            redirectOnly: false,
            newPath: "",
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.CareGapsConfirmationModal.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    toggleMammographyModal = () => {
        logUI("MBHWeb.UI.CareGapsConfirmationModal.StayOnThisPage.Clicked", new Date(), Tools.getURLPath());
        this.setState({ showModal: !this.state.showModal })
    }

    modalContinue = () => {
        this.setState({
            ...this.state,
            showModal: false,
            redirectOnly: true
        }, () => {
            this.props.history.push({ pathname: this.state.newPath });
        });
        logUI("MBHWeb.UI.CareGapsConfirmationModal.Continue.Clicked", new Date(), Tools.getURLPath());
    }

    handleBlockedNavigation = (nextLocation) => {
        this.setState({ ...this.state, showModal: true, newPath: nextLocation.pathname })
        return nextLocation.pathname.includes('/schedulemymammogram')
    }

    render() {
        const { showModal, newPath, redirectOnly } = this.state;

        return (
            redirectOnly
                ? <Redirect to={{ pathname: newPath }} />
                : <>
                <Modal
                    isOpen={showModal}
                    alignText="left"
                    alignFooter="right"
                    toggle={this.toggleMammographyModal}
                    modalHeader="Cancel updating your medical history"
                    modalBody={"Are you sure you want to leave? The information you have provided will be not be saved."}
                    modalFooterButtons={[
                        {
                            label: "Stay on this page",
                            onClick: this.toggleMammographyModal
                        },
                        {
                            label: "Continue",
                            onClick: this.modalContinue
                        },
                    ]}
                >
                </Modal>
                <Prompt message={(nextLocation) => this.handleBlockedNavigation(nextLocation)} />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
    };
};

export default connect(mapStateToProps)(CareGapsConfirmationModal);